export default "__VITE_ASSET__5lCuwvA5__"